"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentRescoreResultSchema = void 0;
const z = require("zod");
const experiment_error_profile_types_1 = require("../../../PackageDataAdjudication/experiment-error-profile.types");
const experiment_dataset_1 = require("./experiment-dataset");
const experiment_scoring_1 = require("./experiment-scoring");
exports.ExperimentRescoreResultSchema = z.object({
    scoring: experiment_scoring_1.ExperimentScoringSchema,
    dataset: experiment_dataset_1.ExperimentDatasetRefSchema,
    changedPackages: experiment_dataset_1.ChangedDatasetPackageSchema.array(),
    carriedOverScoreKeys: z.string().array(),
    profile: experiment_error_profile_types_1.ExperimentErrorProfileSchema,
});
//# sourceMappingURL=experiment-rescore.js.map